import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-ink text-white/80 mt-0" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center">
            <img
              src={`${process.env.PUBLIC_URL}/logo-white.png`}
              alt="Iridescent Medical Spa"
              className="h-10 w-auto"
            />
          </Link>
          <p className="mt-5 text-sm leading-relaxed text-white/50 font-light">
            Expert-led medical aesthetics &amp; wellness in Clinton Township, Michigan.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            {[
              ["Services", "/services"],
              ["Membership", "/membership"],
              ["Rewards", "/rewards"],
              ["Financing", "/financing"],
              ["Journal", "/blog"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-white/60 hover:text-white transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Visit</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-iri-start" /> 42855 Garfield Rd, Suite 105, Clinton Twp, MI 48038</li>
            <li className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 shrink-0 text-iri-start" /> 586.690.8693</li>
            <li className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 shrink-0 text-iri-start" /> hello@iridescent-spa.com</li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Hours</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li className="flex justify-between"><span>Monday</span><span>Closed</span></li>
            <li className="flex justify-between"><span>Tuesday</span><span>10am – 7pm</span></li>
            <li className="flex justify-between"><span>Wednesday</span><span>10am – 5pm</span></li>
            <li className="flex justify-between"><span>Thursday</span><span>10am – 5pm</span></li>
            <li className="flex justify-between"><span>Friday</span><span>10am – 7pm</span></li>
            <li className="flex justify-between"><span>Saturday</span><span>10am – 7pm</span></li>
            <li className="flex justify-between"><span>Sunday</span><span>Closed</span></li>
          </ul>
          <div className="flex gap-3 mt-6">
            <a href="https://www.instagram.com/iridescentspa.mi/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-9 w-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/10 transition-colors">
              <Instagram className="h-4 w-4" />
            </a>
            <a href="https://www.facebook.com/p/Iridescent-Medical-Spa-100093679384852/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="h-9 w-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/10 transition-colors">
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Iridescent Wellness Spa. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <span>Clinton Township · Livonia · Michigan</span>
            <Link to="/admin" data-testid="footer-staff-link" className="text-white/40 hover:text-white transition-colors">
              Staff Portal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
